// v0.5.0f — Walkthrough A (single-txn) decision UI.
//
// Two large buttons:
//   REAL RATE (file today) — routes to manual box (DE/FR) or
//     becomes an explainer + Flag-only button (ES/UK/IT).
//   DATA MISTAKE (drop, file today) — DISABLED with the KL-1
//     expandable explainer.
import React from "react";
import { useTranslation } from "react-i18next";
import { InspectKL1Panel } from "./InspectKL1Panel";

const fmtMoney = (s) => {
  const n = Number(s);
  if (!Number.isFinite(n)) return s;
  return n.toLocaleString(undefined, {
    minimumFractionDigits: 2, maximumFractionDigits: 2,
  });
};

export const InspectDecisionA = ({
  offender, country, supportsRoute, manualBoxId,
  txn0, pickDecision, flagged, flagBusy,
  calcId, txnIds, txnCount,
}) => {
  const { t } = useTranslation();
  const cc = (country || "").toUpperCase();
  return (
    <div
      data-testid={`inspect-decision-a-${offender.rate}`}
      className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-4"
    >
      {supportsRoute ? (
        <button
          type="button"
          data-testid={`inspect-real-rate-btn-${offender.rate}`}
          data-resolution-class="self-resolve"
          data-resolution-endpoint="POST /api/runs/calc/{calc_id}/txn-override"
          onClick={() => pickDecision("real_rate_single")}
          className="text-left p-4 rounded-lg border-2 border-emerald-500 bg-emerald-50 dark:bg-emerald-950/30 hover:bg-emerald-100 dark:hover:bg-emerald-900/40 text-emerald-900 dark:text-emerald-100"
        >
          <div className="font-bold text-sm">{t("ui.country_return.inspect.real_rate_assign_title", { defaultValue: "Real rate — assign and file today" })}</div>
          <div className="text-xs leading-snug mt-2">
            {t("ui.country_return.inspect.real_rate_assign_body", {
              amount: fmtMoney(txn0?.net_amount), cc, box: manualBoxId,
              defaultValue: `Assign €${fmtMoney(txn0?.net_amount)} into ${cc} manual-other-rates box (Kz ${manualBoxId}) and report the rate to the maintainer.`,
            })}
          </div>
        </button>
      ) : (
        <div
          data-testid={`inspect-real-rate-no-box-${offender.rate}`}
          className="text-left p-4 rounded-lg border-2 border-slate-300 dark:border-slate-700 bg-slate-50 dark:bg-slate-900/40 text-slate-700 dark:text-slate-200"
        >
          <div className="font-bold text-sm">{t("ui.country_return.inspect.real_rate_no_box_title", { defaultValue: "Real rate — cannot file today" })}</div>
          <div className="text-xs leading-snug mt-2">
            {t("ui.country_return.inspect.real_rate_no_box_body", {
              cc,
              defaultValue: `${cc} has no “sales at other rates” box on this form. New rates have to be added by the maintainer before this filing can submit.`,
            })}
          </div>
          <button
            type="button"
            data-testid={`inspect-flag-only-btn-${offender.rate}`}
            data-resolution-class="recordkeeping"
            data-resolution-endpoint="POST /api/calc/{calc_id}/rate-table-drift-flags"
            onClick={() => pickDecision("fix_upstream")}
            disabled={flagged || flagBusy}
            className="mt-3 text-xs font-semibold px-3 py-1.5 rounded-md border border-rose-400 text-rose-700 dark:text-rose-200 hover:bg-rose-100 dark:hover:bg-rose-900/40 disabled:opacity-50"
          >
            {flagged ? t("ui.country_return.inspect.reported", { defaultValue: "✓ Reported" }) : t("ui.country_return.inspect.report_rate", { defaultValue: "Report rate to maintainer" })}
          </button>
        </div>
      )}
      <InspectKL1Panel
        offenderRate={offender.rate}
        calcId={calcId}
        txnIds={txnIds}
        txnCount={txnCount}
        country={country}
      />
    </div>
  );
};

export default InspectDecisionA;
